<template>
  <div>
    <hi-modal ref="product" @Ok="save" ok-title="ذخیره اطلاعات" cancel-title="انصراف" :show-header="false">
      <template v-slot:body>
        <b-tabs content-class="mt-3" class="product-tabs">
          <form class="text-right">
            <b-tab title="مشخصات محصول" active>
              <p class="desc-modal" v-if="false">از طریق این قسمت میتوانید ایام و ساعاتی را برای بازدید ملک مذکور درخواست نمایید. کارشناسان آگهی جهت هماهنگی بیشتر با شما تماس خواهند گرفت.</p>
              <div class="form-row">
                <div
                  class="form-group col-md-6 input-hi"
                  :class="{
                    validated: $v.product.title.$error
                  }"
                >
                  <label for="title"
                    >عنوان <span class="input-length">({{ product.title.length }})</span></label
                  >
                  <input type="text" class="form-control" id="title" v-model.trim="product.title" placeholder="عنوان محصول را وارد کنید" :state="validateState('title')" />
                  <div class="invalid-feedback" v-if="!$v.product.title.required">عنوان را وارد کنید.</div>
                  <div class="invalid-feedback" v-if="!$v.product.title.minLength">عنوان می بایست بیش از {{ $v.product.title.$params.minLength.min }} حرف باشد.</div>
                  <div class="invalid-feedback" v-if="!$v.product.title.maxLength">عنوان حداکثر باید {{ $v.product.title.$params.maxLength.max }} حرف باشد.</div>
                </div>
                <div
                  class="form-group col-md-6 input-hi"
                  :class="{
                    validated: $v.product.latinTitle.$error
                  }"
                >
                  <label for="latinTitle"
                    >عنوان لاتین <span class="input-length">({{ product.latinTitle.length }})</span></label
                  >
                  <input type="text" class="form-control ltr" id="latinTitle" v-model="product.latinTitle" :state="validateState('latinTitle')" placeholder="عنوان لاتین را وارد کنید" />
                  <div class="invalid-feedback" v-if="!$v.product.latinTitle.englishLetters">عنوان لاتین را به انگلیسی وارد کنید.</div>
                  <div class="invalid-feedback" v-if="!$v.product.latinTitle.minLength">عنوان لاتین می بایست بیش از {{ $v.product.latinTitle.$params.minLength.min }} حرف باشد.</div>
                  <div class="invalid-feedback" v-if="!$v.product.latinTitle.maxLength">عنوان لاتین حداکثر باید {{ $v.product.latinTitle.$params.maxLength.max }} حرف باشد.</div>
                </div>
              </div>
              <div class="form-row">
                <div
                  class="form-group col-md-6 input-hi"
                  :class="{
                    validated: submitted && !isGroupSelected
                  }"
                >
                  <label for="groups">گروه محصول</label>
                  <span class="add-group">
                    <a href="javascript:;" v-b-modal.new-group>(اضافه کردن گروه جدید)</a>
                    <!-- <a href="javascript:;" @click="showGroupModal">(اضافه کردن گروه جدید)</a> -->
                  </span>
                  <multiselect
                    id="groups"
                    class="product-selection"
                    v-model="product.groups"
                    placeholder="جستجو کنید"
                    label="title"
                    track-by="id"
                    :options="groupOptions"
                    :multiple="true"
                    :taggable="true"
                    group-values="items"
                    group-label="title"
                    tagPosition="bottom"
                    selectedLabel="انتخاب شده"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__single" v-if="values.length > 3 &amp;&amp; !isOpen">{{ values.length }} مورد انتخاب شده</span>
                    </template>
                  </multiselect>
                  <div class="invalid-feedback" v-if="!isGroupSelected">حداقل یک گروه برای محصول انتخاب کنید.</div>
                </div>
                <div
                  class="form-group col-md-6 input-hi"
                  :class="{
                    validated: submitted && !isBrandSelected
                  }"
                >
                  <label for="brand">برند</label>
                  <span class="add-group">
                    <a href="javascript:;" v-b-modal.new-brand>(اضافه کردن برند جدید)</a>
                  </span>
                  <multiselect id="brand" class="product-selection" v-model="product.brand" placeholder="جستجو کنید" label="title" track-by="id" :options="brandsOptions" :taggable="true">
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__single" v-if="values.length > 3 &amp;&amp; !isOpen">{{ values.length }} مورد انتخاب شده</span>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="list-upload-images">
                    <div class="add-image" tabindex="0" role="button">
                      <input class="file-upload" ref="imageInput" accept="image/jpeg,image/png" multiple="" type="file" hidden="" autocomplete="off" tabindex="-1" @change="previewMultiImage" />
                      <div id="upload_images" @click="selectImage">
                        <div class="box-add-icon">
                          <i class="fa fa-images"></i>
                        </div>
                      </div>
                    </div>
                    <div class="image-item" :class="{ 'default-cover': item.default }" v-for="(item, index) in images_preview" :key="item.preview">
                      <img :src="item.preview" alt="" class="preview-image" @click="setAsDefault(index)" @dblclick="cropImage(index)" />
                      <a href="javascript:;" class="trash-image" @click="removeImage(index)"><i class="fa fa-trash-alt"></i></a>
                      <a href="javascript:;" class="crop-image" v-if="item.default" @click="cropImage(index)"><i class="fa fa-crop"></i></a>
                      <div class="progress">
                        <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="add-visit-form col-12" v-if="false">
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-6 px-2">
                    <label class="lbl-visit">تایم بازدید اول</label>
                    <div class="input-group input-hi has-prepend">
                      <input type="text" class="form-control" placeholder="نام و نام خانوادگی" />
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="icon-user"></i></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="تصاویر">
              <b-card-text>Tab Contents 2</b-card-text>
            </b-tab>
          </form>
        </b-tabs>
      </template>
    </hi-modal>
    <b-modal modal-class="nested-modal" ok-title="ثبت گروه" cancel-title="انصراف" id="new-group" centered title="ایجاد گروه جدید" hide-backdrop @ok="addGroup"
      @hidden="resetGroupModal">
      <div :class="{ validated: group.submited }">
        <label>عنوان</label>
        <b-form-input v-model="group.title" placeholder="عنوان گروه"></b-form-input>
        <div class="invalid-feedback d-block" v-if="!$v.group.title.required">عنوان را وارد کنید.</div>
        <div class="invalid-feedback d-block" v-if="!$v.group.title.minLength">عنوان می بایست بیش از {{ $v.group.title.$params.minLength.min }} حرف باشد.</div>
        <div class="invalid-feedback d-block" v-if="!$v.group.title.maxLength">عنوان حداکثر باید {{ $v.group.title.$params.maxLength.max }} حرف باشد.</div>
      </div>
    </b-modal>
    <b-modal modal-class="nested-modal" ok-title="ثبت برند" cancel-title="انصراف" id="new-brand" centered title="ایجاد برند جدید" hide-backdrop @ok="addBrand"
    @hidden="resetBrandModal">
      <div :class="{ validated: brand.submited }">
        <label>عنوان</label>
        <b-form-input v-model="brand.title" placeholder="عنوان برند"></b-form-input>
        <div class="invalid-feedback d-block" v-if="!$v.brand.title.required">عنوان را وارد کنید.</div>
        <div class="invalid-feedback d-block" v-if="!$v.brand.title.minLength">عنوان می بایست بیش از {{ $v.brand.title.$params.minLength.min }} حرف باشد.</div>
        <div class="invalid-feedback d-block" v-if="!$v.brand.title.maxLength">عنوان حداکثر باید {{ $v.brand.title.$params.maxLength.max }} حرف باشد.</div>
      </div>
    </b-modal>
    <b-modal
      modal-class="nested-modal"
      :hide-header="true"
      ok-title="برش تصویر"
      cancel-title="انصراف"
      id="crop-image"
      centered
      hide-backdrop
      ref="cropperModal"
      static
      :cancel-disabled="true"
      @ok="getCropResult"
      @shown="shown"
    >
      <cropper
        class="cropper"
        ref="cropper"
        :src="product.featureImage"
        :stencil-props="{
          aspectRatio: 1 / 1
        }"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { validationMixin } from "vuelidate"
import { required, minLength, maxLength } from "vuelidate/lib/validators"

import { helpers } from "vuelidate/lib/validators"
const englishLetters = helpers.regex("alpha", /^[0-9\sa-zA-Z]*$/)

import HiModal from "@/view/components/HiModal.vue"
import Multiselect from "vue-multiselect"
import { Cropper } from "vue-advanced-cropper"
import ApiService from "@/core/services/api.service"

export default {
  name: "AddProduct",
  mixins: [validationMixin],
  components: { HiModal, Multiselect, Cropper },
  data() {
    return {
      submitted: false,
      images_preview: [],
      group: {
        title: "",
        submited: false
      },
      brand: {
        title: "",
        submitted: false
      },
      product: {
        id: null,
        title: "",
        latinTitle: "",
        groups: [],
        brand: null,
        status: true,
        type: 0,
        imageCoordinates: null,
        featureImage: null,
        images: []
      },
      progress: 0,
      message: ""
    }
  },
  computed: {
    ...mapGetters({
      groupOptions: "productGroup/getList",
      brandsOptions: "brand/optionList"
    }),
    isGroupSelected() {
      return this.submitted && this.product.groups.length !== 0
    },
    isBrandSelected() {
      return this.submitted && this.product.brand != null
    }
  },
  validations: {
    product: {
      title: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(70)
      },
      latinTitle: {
        minLength: minLength(2),
        maxLength: maxLength(70),
        englishLetters
      }
    },
    group: {
      title: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(70)
      }
    },
    brand: {
      title: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(70)
      }
    }
  },
  methods: {
    ...mapActions({
      groupOptionsList: "productGroup/fetchAsOptionList",
      addSimpleGroup: "productGroup/addSimpleGroup",
      fetchBrands: "brand/fetchAsOptionList",
      addSimpleBrand: "brand/addSimple",
    }),
    openModal: function () {
      this.groupOptionsList()
      this.fetchBrands()
      this.$refs.product.openModal()
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.product[name]
      return $dirty ? !$error : null
    },
    save() {
      this.submitted = true
      console.log(this.product)
      this.$v.product.$touch()
      if (this.$v.product.$invalid) {
        return
      }
    },
    selectImage: function () {
      this.$refs.imageInput.click()
    },
    previewMultiImage: function (event) {
      var input = event.target
      var count = input.files.length
      var index = 0
      if (input.files) {
        while (count--) {
          ApiService.uploadFile("/admin/products/UploadImage", input.files[index], event => {
            this.progress = Math.round((100 * event.loaded) / event.total)
          })
            .then(response => {
              if (response.status == 200) {
                if (this.images_preview.length == 0) {
                  this.images_preview.push({ preview: response.data.image, default: true })
                } else {
                  this.images_preview.push({ preview: response.data.image, default: false })
                }

                this.product.images.push(response.data.image)
              }
              this.message = response.data.message
              return [] //UploadService.getFiles()
            })
            .catch(err => {
              this.progress = 0
              this.message = "Could not upload the image! " + err
              this.currentImage = undefined
            })
          index++
        }
      }
    },
    setAsDefault: function (index) {
      this.images_preview.forEach(element => {
        element.default = false
      })
      this.images_preview[index].default = true

      if (this.product.featureImage !== this.product.images[index]) {
        this.product.imageCoordinates = null
      }

      this.product.featureImage = this.images_preview[index].preview
    },
    cropImage: function (index) {
      if (this.product.imageCoordinates !== null) {
        this.$refs.cropper.setCoordinates({
          width: this.product.imageCoordinates.width,
          height: this.product.imageCoordinates.height,
          left: this.product.imageCoordinates.x,
          top: this.product.imageCoordinates.y
        })
      }
      this.$root.$emit("bv::show::modal", "crop-image")
    },
    removeImage: function (index) {
      this.images_preview = this.images_preview.filter(function (value, i, arr) {
        return index != i
      })
      this.product.images = this.product.images.filter(function (value, i, arr) {
        return index != i
      })
      if (this.images_preview.length === 1) {
        this.setAsDefault(0)
      }

      const dt = new DataTransfer()
      const { files } = this.$refs.imageInput

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        if (index !== i) dt.items.add(file)
      }
      this.$refs.imageInput.files = dt.files
    },
    getCropResult: function () {
      const { coordinates } = this.$refs.cropper.getResult()
      this.product.imageCoordinates = {
        x: coordinates.left,
        y: coordinates.top,
        width: coordinates.width,
        height: coordinates.height
      }
    },
    shown: function () {
      this.$refs.cropper.refresh()
    },
    addGroup(event) {
      event.preventDefault()

      var me = this
      this.group.submited = true
      this.$v.group.$touch()
      if (this.$v.group.$invalid) {
        return
      }
      this.addSimpleGroup({ title: this.group.title })
        .then(response => {
          if (response.data.status) {
            console.log(response.data)
            me.groupOptionsList()
            me.$toast.success(`گروه ${me.group.title} ایجاد گردید.`, "", { displayMode: 2 })
            this.$nextTick(() => {
              this.$bvModal.hide("new-group")
            })
          }
        })
        .catch(error => {
          console.log(error)
          me.$toast.error("متأسفانه مشکلی در ایجاد گروه جدید به وجود آمده است", "", { displayMode: 2 })
          event.preventDefault()
        })
    },
    resetGroupModal() {
      this.group.title = ""
    },
    addBrand(event) {
      event.preventDefault()

      var me = this
      this.$v.brand.$touch()
      if (this.$v.brand.$invalid) {
        return
      }
      this.addSimpleBrand({ title: this.brand.title })
        .then(response => {
          if (response.data.status) {
            me.fetchBrands()
            me.$toast.success(`برند ${me.brand.title} ایجاد گردید.`, "", { displayMode: 2 })
            this.$nextTick(() => {
              this.$bvModal.hide("new-brand")
            })
          }
        })
        .catch(error => {
          console.log(error)
          me.$toast.error("متأسفانه مشکلی در ایجاد برند جدید به وجود آمده است", "", { displayMode: 2 })
          event.preventDefault()
        })
    },
    resetBrandModal() {
      this.brand.title = ""
    }
  },
  mounted() {}
}
</script>